import { render, staticRenderFns } from "./CasoEdit.vue?vue&type=template&id=31d0990e&xmlns=true"
import script from "./CasoEdit.vue?vue&type=script&lang=js"
export * from "./CasoEdit.vue?vue&type=script&lang=js"
import style0 from "./CasoEdit.vue?vue&type=style&index=0&id=31d0990e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports